import { getAllInfoIndex } from '@flexus/utilities';
import moment from 'moment';
import { Validators, UntypedFormGroup, UntypedFormArray } from '@angular/forms';
import { CustomerDetailConfig, FieldConfig } from '@flexus/core';

export function checkPolicyType(pol: string): string {
	if (pol !== undefined && pol !== null) {
		const policy = pol.substring(0, 3);
		// SIL
		const silPolicies = ['HLC', 'BMB', 'HLB', 'EBK'];
		const stansurePolicies = ['STH', 'SHS'];
		if (silPolicies.includes(policy.toUpperCase())) {
			return 'SIL';
		}
		// Stansure
		else if (stansurePolicies.includes(policy.toUpperCase())) {
			return 'StanSure';
		} else {
			return 'SIL';
		}
	} else return null;
}

export const transformJobsToJobCardRequest = (jobcards, storeObj, formValue, bf) => {
	if (jobcards !== undefined && jobcards !== null) {
		return jobcards
			.filter(job => {
				const hasVoucher = !!job?.voucher_id || !!job?.voucher_type_id;
				const hasSkill = !!job?.skill_id && !!job?.providertype_id;
				return hasVoucher || hasSkill;
			})
			.map(job => {
				console.log('transformJobsToJobCardRequest job', job);
				const skillId = job?.skill_id ?? job?.voucher_skill ?? null;
				const appointmentType = job?.appointmentTime != null ? Number(job?.appointmentTime) : null;
				const rangeStart = job?.range_start;
				const rangeEnd = job?.range_end;
				const rangeStartTime =
					typeof rangeStart === 'string' ? rangeStart : rangeStart?.hour != null ? `${rangeStart.hour}:${rangeStart.minutes}` : null;
				const rangeEndTime =
					typeof rangeEnd === 'string' ? rangeEnd : rangeEnd?.hour != null ? `${rangeEnd.hour}:${rangeEnd.minutes}` : null;
				const appointmentTimePickerTime =
					job?.appointmentTimePicker ? `${job?.appointmentTimePicker?.hour}:${job?.appointmentTimePicker?.minutes}` : null;
				const requestedAppointmentTime =
					job?.appointmentTimePicker && appointmentType !== 3 ? appointmentTimePickerTime : rangeStartTime;
				const appointmentDate = job?.appointmentDatePicker ? moment(job?.appointmentDatePicker) : null;
				const formatDateTime = (dateBase, timeValue) => {
					if (!dateBase || !timeValue) return null;
					const [hour, minutes] = String(timeValue).split(':');
					const cloned = dateBase.clone();
					cloned.hour(Number(hour));
					cloned.minutes(Number(minutes));
					return cloned.format('YYYY-MM-DDTHH:mm:ss');
				};
				const rangeStartDateTime = formatDateTime(appointmentDate, rangeStartTime ?? requestedAppointmentTime);
				const rangeEndDateTime = formatDateTime(
					appointmentDate,
					rangeEndTime ?? rangeStartTime ?? requestedAppointmentTime
				);
				let jobExtras = {};
				if (job?.providertype_id === 2) {
					jobExtras = {
						initials: job?.bank_details?.initials,
						surname: job?.bank_details?.account_holder_name,
						bank_acc_number: job?.bank_details?.account_number,
						acc_type: job?.bank_details?.acc_type,
						acc_type_desc: getAllInfoIndex('account_type', 'mid', 'description', job?.bank_details?.acc_type, storeObj),
						idnumber: job?.bank_details?.identification_number,
						branch_code: job?.bank_details?.branch_code,
						bank: job?.bank_details?.bank_name,
						branch: job?.bank_details?.branch,
						isnonpanel: job?.bank_details?.account_use === 'Individual' ? false : true,
						avsresult: job?.bank_details?.avsSuccess,
						avsinitialsfailreason: job?.bank_details?.avsFailedReasons
					};
				} else if (job?.providertype_id === 3) {
					// off panel
				}

				const theRes = {
					...jobExtras,
					skillrequested: job?.skillrequested ? job?.skillrequested : skillId || 0,
					skill: job?.skill ? job?.skill : null,
					skill_id: skillId,
					skillcatagory_id: job?.skillcatagory_id,
					skillcatagory: job?.skillcatagory ? job?.skillcatagory : null,
					providertype: job?.providertype ? job?.providertype : null,
					providertype_id: !bf.bigForm?.value?.upfrontrepudiation ? (job?.providertype_id ? job?.providertype_id : null) : 7,
					claim_type_id: job?.voucher_claim_type ?? null,

					requestedappointmentdate: job?.appointmentDatePicker ? moment(job?.appointmentDatePicker).format('YYYY-MM-DD') : null,
					requestedappointmenttime: requestedAppointmentTime,
					requestedappointmentendtime: appointmentType === 3 ? rangeEndTime : null,
					range_start:
						appointmentType === 3
							? rangeStartDateTime
							: formatDateTime(appointmentDate, appointmentTimePickerTime ?? rangeStartTime ?? requestedAppointmentTime),
					range_end:
						appointmentType === 3
							? rangeEndDateTime ?? rangeStartDateTime
							: formatDateTime(appointmentDate, appointmentTimePickerTime ?? rangeEndTime ?? rangeStartTime ?? requestedAppointmentTime),
					appointment_type_id: appointmentType ?? null,
					appointment_type: appointmentType ? getAllInfoIndex('appointment_types', 'id', 'name', appointmentType, storeObj) : null, // at before
					appointmentdatetype: job?.appointmentDateType ? job?.appointmentDateType : null,
					voucher_id: job?.voucher_id ?? null,
					voucher_type: job?.voucher_type ?? null,
					voucher_type_id: job?.voucher_type_id ?? null,
					voucher_name: job?.voucher_name ?? null,
					voucher_description: job?.voucher_description ?? null,
					// voucher_terms: job?.voucher_terms ?? null,
					// voucher_product_template: job?.voucher_product_template ?? null,
					quantity: job?.quantity ?? 1,
					store_poi: job?.store_poi ?? null,
					what_is_being_installed: job?.what_is_being_installed ?? null,
					collection_required: !!job?.collection_required,
					store_has_stock: !!job?.store_has_stock,
					delivery_cost: job?.delivery_cost ?? null,
					where_to_collect: job?.where_to_collect ?? null,

					// excess: [
					// 	{
					// 		excess_amount: job?.amount ? job?.amount : null,
					// 		excess_description: job?.excess_description || null,
					// 		who_collects_excess: job?.who_collects ? job?.who_collects : null,
					// 		who_collects_excess_desc: job?.who_collects ? getAllInfoIndex('excess_who', 'id', 'name', job?.who_collects, storeObj) : null,
					// 		excess_payment_method: job?.payment_method ? job?.payment_method : null,
					// 		excess_payment_method_desc: !job?.is_cancelled && job?.payment_method ? getAllInfoIndex('excess_how', 'id', 'name', job?.payment_method, storeObj) : null
					// 	}
					// ]
				};
				console.log('transformJobsToJobCardRequest payload', {
					requestedappointmenttime: theRes.requestedappointmenttime,
					range_start: theRes.range_start,
					range_end: theRes.range_end
				});
				if (job?.is_cancelled) {
					const withoutExcess = { ...theRes };
					// delete withoutExcess.excess;
					return withoutExcess;
				}
				return theRes;
			})
			.map((job, index) => {
				const pExcess = bf.bigForm?.value?.policy_excess;
				if (index === 0 && pExcess && pExcess.amount !== 0) {
					const policyExcess = {
						excess_amount: pExcess.amount ? pExcess.amount : null,
						excess_description: pExcess?.excess_description,
						who_collects_excess: pExcess.who_collects ? pExcess.who_collects : null,
						who_collects_excess_desc: pExcess.who_collects
							? getAllInfoIndex('excess_who', 'id', 'name', pExcess.who_collects, storeObj)
							: null,
						excess_payment_method: pExcess.payment_method ? pExcess.payment_method : null,
						excess_payment_method_desc: pExcess.payment_method
							? getAllInfoIndex('excess_how', 'id', 'name', pExcess.payment_method, storeObj)
							: null
					};
					const excess = job?.excess ? [{ ...policyExcess }, ...(job?.excess ?? [])] : [{ ...policyExcess }];
					return pExcess && pExcess.is_cancelled ? job : { ...job, excess };
				}
				return job;
			});
	}
	return null;
};

export const transformJobsToVouchersPayload = (jobcards, _storeObj, formValue) => {
	if (!Array.isArray(jobcards)) {
		return [];
	}

	const normalizePhone = (value: unknown) => {
		if (value == null) return null;
		const str = String(value).trim();
		return str.length > 0 ? str : null;
	};
	const cellnumber =
		normalizePhone(formValue?.contact_details?.cell_number) ??
		normalizePhone(formValue?.contact_details?.contact_number) ??
		normalizePhone(formValue?.applicant?.contact_number) ??
		null;

	const formatDateTime = (dateBase: moment.MomentInput | null | undefined, timeValue: string | null) => {
		if (!dateBase || !timeValue) return null;
		const [hour, minutes] = String(timeValue).split(':');
		const cloned = moment(dateBase).clone();
		cloned.set({
			hour: Number(hour),
			minute: Number(minutes),
			second: 0,
			millisecond: 0
		});
		return cloned.format('YYYY-MM-DDTHH:mm:ss');
	};

	return jobcards
		.filter(job => !!job)
		.map(job => {
			const totalCost = job?.total_cost ?? null;
			const quantityAvailable = job?.quantity_available ?? null;
			const deliveryDistance = job?.delivery_distance ?? null;
			const appointmentTypeId = job?.appointmentTime ?? job?.appointment_type_id ?? null;
			const appointmentDateMoment = job?.appointmentDatePicker ? moment(job?.appointmentDatePicker) : null;
			const timeFromPicker = job?.appointmentTimePicker
				? `${job?.appointmentTimePicker?.hour}:${job?.appointmentTimePicker?.minutes}`
				: null;
			const rangeStartTime =
				typeof job?.range_start === 'string'
					? job.range_start
					: job?.range_start?.hour != null
					? `${job.range_start.hour}:${job.range_start.minutes}`
					: null;
			const rangeEndTime =
				typeof job?.range_end === 'string'
					? job.range_end
					: job?.range_end?.hour != null
					? `${job.range_end.hour}:${job.range_end.minutes}`
					: null;

			// Backend requirement: appointment must include range_start as ISO datetime, e.g. "2026-02-10T13:00:00"
			const computedRangeStart =
				appointmentTypeId === 3
					? formatDateTime(appointmentDateMoment, rangeStartTime)
					: formatDateTime(appointmentDateMoment, timeFromPicker ?? rangeStartTime);
			const computedRangeEnd =
				appointmentTypeId === 3
					? formatDateTime(appointmentDateMoment, rangeEndTime ?? rangeStartTime)
					: formatDateTime(appointmentDateMoment, rangeEndTime ?? timeFromPicker ?? rangeStartTime)
						?? computedRangeStart;

				return {
				store_poi: job?.store_poi ?? null,
				what_is_being_installed: job?.what_is_being_installed ?? null,
				terms: job?.terms ?? null,
				title: job?.title ?? null,
				total_cost: totalCost != null ? Number(totalCost) : null,
				delivery_cost: job?.delivery_cost ?? null,
				delivery_distance: deliveryDistance != null ? Number(deliveryDistance) : null,
				quantity_available: quantityAvailable != null ? Number(quantityAvailable) : null,
				has_stock: job?.store_has_stock ? 1 : 0,
				cellnumber,
				collection: job?.collection_required ? 1 : 0,
				voucher_type_id: job?.voucher_id ?? null,
				quantity: job?.quantity ?? 1,
				skill_id: job?.voucher_type?.skill ?? job?.voucher_skill ?? job?.skill_id ?? null,
				appointment: {
					range_start: computedRangeStart,
					...(computedRangeEnd != null ? { range_end: computedRangeEnd } : {}),
					appointment_type: appointmentTypeId,
				}
			};
		});
};

/**
 * For Pinggo create_claim:
 * Add the selected voucher "name" (root field from get_voucher_types payload objects)
 * to the root of loan_information as `voucher_type`.
 *
 * Example expected output: "Artificial Grass" (string)
 */
export const buildLoanInformationVoucherType = (jobcards) => {
	if (!Array.isArray(jobcards) || jobcards.length === 0) {
		return null;
	}

	const firstJob = jobcards[0] ?? null;
	const raw =
		firstJob?.voucher_name ??
		firstJob?.title ??
		null;

	if (raw == null) {
		return null;
	}

	const value = String(raw).trim();
	return value.length > 0 ? value : null;
};

/**
 * For Pinggo create_claim:
 * Add the first job's what_is_being_installed to the root of loan_information.
 * No validation; included in payload only.
 */
export const buildLoanInformationWhatIsBeingInstalled = (jobcards) => {
	if (!Array.isArray(jobcards) || jobcards.length === 0) {
		return null;
	}
	const firstJob = jobcards[0] ?? null;
	const raw = firstJob?.what_is_being_installed;
	if (raw == null || raw === '') {
		return null;
	}
	const value = String(raw).trim();
	return value.length > 0 ? value : null;
};

/**
 * Builds the additional_identities array for loan_information from the tenant config
 * and the first job's identity form controls.
 *
 * Output shape:
 * [{ identity_type: "membership", identity: "<user-entered value>" }, ...]
 */
export const buildAdditionalIdentitiesPayload = (_jobcards, _storeObj, formValue) => {
	const identities = formValue?.tenant_document_config?.metadata?.additional_identities ?? [];
	if (!Array.isArray(identities) || identities.length === 0) {
		return undefined;
	}

	const firstJob = Array.isArray(formValue?.jobs) && formValue.jobs.length > 0 ? formValue.jobs[0] : null;
	if (!firstJob) {
		return undefined;
	}

	const result = identities
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		.map((cfg: any) => {
			const controlName = `identity_${cfg.identity_type}`;
			const value = firstJob[controlName] ?? null;
			return value != null ? { identity_type: cfg.identity_type, identity: value } : null;
		})
		.filter(Boolean);

	return result.length > 0 ? result : undefined;
};

/**
 * Builds the `loan_information.values` object containing the voucher's
 * sp_value, client_value and total_value (all coerced to numbers).
 *
 * Returns null when no values are available so the key is omitted from the payload.
 */
export const buildLoanInformationValues = (jobcards) => {
	if (!Array.isArray(jobcards) || jobcards.length === 0) {
		return null;
	}

	const firstJob = jobcards[0] ?? null;
	if (!firstJob) {
		return null;
	}

	const toNum = (val: unknown): number | null => {
		if (val == null) return null;
		const n = Number(val);
		return Number.isFinite(n) ? n : null;
	};

	const sp_value = toNum(firstJob.sp_value);
	const client_value = toNum(firstJob.client_value);
	const total_value = toNum(firstJob.total_value);

	if (sp_value == null && client_value == null && total_value == null) {
		return null;
	}

	return {
		...(sp_value != null ? { sp_value } : {}),
		...(client_value != null ? { client_value } : {}),
		...(total_value != null ? { total_value } : {})
	};
};

export const buildAddressPayload = (_val, _storeObj, formValue) => {
	const firstJob = Array.isArray(formValue?.jobs) ? formValue.jobs[0] : null;
	const streetAddress = formValue?.insured_address?.street_address ?? formValue?.address ?? null;
	const suburb = formValue?.insured_address?.suburb ?? formValue?.suburb ?? null;
	const city = formValue?.insured_address?.city ?? formValue?.city ?? null;
	const postalCode = formValue?.insured_address?.postal_code ?? formValue?.postal_code ?? null;
	const claimProvince = formValue?.province ?? formValue?.claimprovince ?? null;

	const addressSearchedParts = [streetAddress, suburb, city, postalCode].filter(Boolean);
	const addressSearched = addressSearchedParts.length > 0 ? addressSearchedParts.join(', ') : null;

	return {
		area_id: formValue?.area_code ?? null,
		store_poi: formValue?.address_store_poi ?? firstJob?.store_poi ?? null,
		address_searched: addressSearched ?? formValue?.address_searched ?? null,
		from_lat: formValue?.address_from_lat ?? formValue?.latitude ?? null,
		address_found: formValue?.address_found ?? null,
		address: streetAddress,
		suburb,
		postal_code: postalCode,
		claimprovince: claimProvince,
		to_lat: formValue?.address_to_lat ?? formValue?.latitude ?? null,
		from_lng: formValue?.address_from_lng ?? formValue?.longitude ?? null,
		to_lng: formValue?.address_to_lng ?? formValue?.longitude ?? null
	};
};

// Clears validators on fields not needed once repudiated and resets them after.
export function toggleUpfrontValidation(toggle: boolean, bf: UntypedFormGroup) {
	const jobs = bf.get('jobs') as UntypedFormArray;
	const controls = jobs.controls;
	for (let index = 0; index < controls.length; index++) {
		if (toggle) {
			removeValidators(controls[index] as UntypedFormGroup);
		} else {
			checkBusinessRules(controls[index] as UntypedFormGroup);
		}
	}
}

export function checkBusinessRules(bf: UntypedFormGroup) {
	if (bf.get('jobs')) {
		const jobs = bf.get('jobs') as UntypedFormArray;
		const controls = jobs.controls;
		for (let index = 0; index < controls.length; index++) {
			const formControl = controls[index] as UntypedFormGroup;
			if (
				formControl.get('providertype_id') &&
				formControl.get('assessorWaived') &&
				formControl.get('skill_id') &&
				formControl.get('providertype_id')?.value !== 2 &&
				!!formControl.get('assessorWaived')?.value === false &&
				formControl.get('skill_id')?.value !== 44
			) {
				// skill 44 is an internal assessor
				addAppointmentValidators(formControl);
			} else {
				removeAppointmentValidators(formControl);
			}
			if (!((formControl.get('is_cancelled') && !!formControl.get('is_cancelled')?.value) || (formControl.get('assessorWaived') && !!formControl.get('assessorWaived')?.value))) {
				addExcessValidators(formControl);
			} else {
				removeExcessValidators(formControl);
			}
		}
	}
}

function removeValidators(control: UntypedFormGroup) {
	for (const key in control.controls) {
		if (control.get(key)) {
			if (key !== 'bank_details') {
				control.get(key)?.clearValidators();
				control.get(key)?.updateValueAndValidity();
			}
		}
	}
}

function addExcessValidators(formControl: UntypedFormGroup) {
	if (formControl.get('amount')) {
		formControl.get('amount')?.setValidators([Validators.required]);
		formControl.get('amount')?.updateValueAndValidity();
	}
	if (formControl.get('who_collects')) {
		formControl.get('who_collects')?.setValidators([Validators.required]);
		formControl.get('who_collects')?.updateValueAndValidity();
	}
	if (formControl.get('payment_method')) {
		formControl.get('payment_method')?.setValidators([Validators.required]);
		formControl.get('payment_method')?.updateValueAndValidity();
	}
}

function addAppointmentValidators(formControl: UntypedFormGroup) {
	if (formControl.get('appointmentTime')) {
		formControl.get('appointmentTime')?.setValidators([Validators.required]);
		formControl.get('appointmentTime')?.updateValueAndValidity();
	}
	if (formControl.get('appointmentTimePicker')) {
		formControl.get('appointmentTimePicker')?.setValidators([Validators.required]);
		formControl.get('appointmentTimePicker')?.updateValueAndValidity();
	}
}

function removeExcessValidators(formControl: UntypedFormGroup) {
	if (formControl.get('amount')) {
		formControl.get('amount')?.clearValidators();
		formControl.get('amount')?.updateValueAndValidity();
	}
	if (formControl.get('who_collects')) {
		formControl.get('who_collects')?.clearValidators();
		formControl.get('who_collects')?.updateValueAndValidity();
	}
	if (formControl.get('payment_method')) {
		formControl.get('payment_method')?.clearValidators();
		formControl.get('payment_method')?.updateValueAndValidity();
	}
}

function removeAppointmentValidators(formControl: UntypedFormGroup) {
	if (formControl.get('appointmentTime')) {
		formControl.get('appointmentTime')?.clearValidators();
		formControl.get('appointmentTime')?.updateValueAndValidity();
	}
	if (formControl.get('appointmentTimePicker')) {
		formControl.get('appointmentTimePicker')?.clearValidators();
		formControl.get('appointmentTimePicker')?.updateValueAndValidity();
	}
}

/**
 * Builds a dynamic mapper object from CustomerDetailConfig that can be merged into bigFormToStoreMapper.
 * This allows tenant-specific fields to be automatically mapped to store paths.
 * 
 * @param config - The CustomerDetailConfig containing field definitions with storePath
 * @returns A mapper object with form control paths as keys and store paths as values
 */
export function buildDynamicMapper(config: CustomerDetailConfig): Record<string, string | string[]> {
	const mapper: Record<string, string | string[]> = {};

	// Helper function to add mapping for a field
	const addFieldMapping = (field: FieldConfig, groupName: string) => {
		if (field.storePath) {
			const formPath = `${groupName}.${field.controlName}`;
			mapper[formPath] = Array.isArray(field.storePath) 
				? field.storePath 
				: field.storePath;
		}
	};

	// Customer details fields
	config.customerDetails?.fields?.forEach(field => {
		addFieldMapping(field, 'client_details');
	});

	// Contact details fields
	config.contactDetails?.fields?.forEach(field => {
		addFieldMapping(field, 'contact_details');
	});

	// Address details - combine all address fields
	const addressFields = [
		...(config.addressDetails?.commonFields ?? []),
		...(config.addressDetails?.houseEstateFields ?? []),
		...(config.addressDetails?.flatOfficeFields ?? [])
	];
	addressFields.forEach(field => {
		addFieldMapping(field, 'insured_address');
	});

	return mapper;
}
